import { render } from "./ProductsModalAddToCartForSeveralProducts.vue?vue&type=template&id=6b0f8093"
import script from "./ProductsModalAddToCartForSeveralProducts.vue?vue&type=script&lang=js"
export * from "./ProductsModalAddToCartForSeveralProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__